import { isAssistantMessageShellEmpty, type UIMessagePartsLike, type UIMessageRoleLike } from './data-suggestions';
import { messageHasActiveOrFailedToolProgress } from './tool-progress';

export type AdvisorThreadMessageEntry<TMessage extends UIMessagePartsLike & UIMessageRoleLike> = {
  message: TMessage;
  text: string;
};

export type AdvisorThreadPresentation<TMessage extends UIMessagePartsLike & UIMessageRoleLike> = {
  visibleMessageEntries: AdvisorThreadMessageEntry<TMessage>[];
  showThinkingIndicator: boolean;
};

/** Shared org/partner/admin Kin panel thread visibility + thinking-indicator rules. */
export function resolveAdvisorThreadPresentation<TMessage extends UIMessagePartsLike & UIMessageRoleLike>(
  messageEntries: AdvisorThreadMessageEntry<TMessage>[],
  busy: boolean
): AdvisorThreadPresentation<TMessage> {
  const lastMessage = messageEntries[messageEntries.length - 1];
  const trailingEmptyAssistantIndex =
    lastMessage?.message.role === 'assistant' &&
    isAssistantMessageShellEmpty(lastMessage.message, lastMessage.text, busy)
      ? messageEntries.length - 1
      : -1;
  const hasTrailingEmptyAssistant = trailingEmptyAssistantIndex >= 0;
  const visibleMessageEntries = messageEntries.filter((_, idx) => idx !== trailingEmptyAssistantIndex);
  const lastAssistantHasVisibleTools =
    lastMessage?.message.role === 'assistant' && messageHasActiveOrFailedToolProgress(lastMessage.message);
  const showThinkingIndicator =
    busy && !lastAssistantHasVisibleTools && (lastMessage?.message.role === 'user' || hasTrailingEmptyAssistant);

  return { visibleMessageEntries, showThinkingIndicator };
}
